import type { ReactElement } from "react"

import type { TEmptyCallback, TEmptyRenderCallback } from "@/shared/types/functions"

type TAccordionRenderFunction = (isExpanded: boolean, helpers?: { toggle?: TEmptyCallback }) => ReactElement

enum EAccordionColorVariant {
    Accent = "accent",
    White = "white",
    WhiteMuted = "whiteMuted", // cancelled session-info
    Orange = "orange"
}

enum EAccordionBordersVariant {
    Bordered = "bordered",
    ThinBordered = "thinBordered",
    NoBordered = "noBordered"
}

type TAccordionProps = {
    containerClassName?: string
    renderHeader: TAccordionRenderFunction | ReactElement
    renderBody: TAccordionRenderFunction | ReactElement
    renderIcons?: (TAccordionRenderFunction | TEmptyRenderCallback)[]
    colorVariant: EAccordionColorVariant
    bordersVariant: EAccordionBordersVariant
    withHoverColors?: boolean
    onExpand?: TEmptyCallback
    iconClassName?: string
    isExpandable?: boolean
    isDefaultExpanded?: boolean
    headerBorderRadius?:
        | number
        | {
              expanded: { tl: number; tr: number; br: number; bl: number }
              collapsed: { tl: number; tr: number; br: number; bl: number }
          }
}

export type { TAccordionProps, TAccordionRenderFunction }
export { EAccordionColorVariant, EAccordionBordersVariant }
